<report-filter
showCostCenters='true'
showFacilities='true'
showViews='true'
showPeriodEndDateSelection='true'
defaultPayPeriodsBack=1
[(defaultView)]='defaultView'
[(views)]="views"
showVarianceType='true'
[(varianceTypes)]="varianceTypes"
[(defaultVarianceType)]="defaultVarianceType"
[(defaultFilter)]="filters"
(filterUpdated)="filterUpdated($event)">
</report-filter>

<hr/>

<smt-executive-variance-report
[filtersUpdated]='filterEventsSubject.asObservable()'
[(reportFilters)]='filters'>
</smt-executive-variance-report>
